import { Component, OnInit, Output, EventEmitter } from '@angular/core';
import { IWidget, NewLineWidget } from "src/app/models/dashboard";
import { WidgetComponent } from 'src/app/views/dashboard/widgets/widget/widget.component';
import { Dashboard } from 'src/api/models';

@Component({
  selector: 'app-new-line-widget',
  templateUrl: './new-line-widget.component.html',
  styleUrls: ['./new-line-widget.component.css']
})
export class NewLineWidgetComponent implements OnInit, IWidget {
  @Output() dashboardSelected = new EventEmitter<any>();
  @Output() widgetSelected = new EventEmitter<any>();
  
  state:any;
  widgetComponent: WidgetComponent;
  widget: NewLineWidget;
  dashboard: Dashboard;
  uri: string;

  loadComplete(){
    
  }
  
  constructor() { }

  ngOnInit() {
  }

}
